import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/store';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import history from './utils/history';
import config from './utils/config';
import * as Sentry from '@sentry/react';
import 'bootstrap/scss/bootstrap.scss';
import './index.scss';
import { loadState } from './utils/localStorage';
import ErrorFallback from './components/errorFallback';

const persistedState = loadState();
const store = configureStore(persistedState);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: config.SENTRY_DSN,
    environment: window.location.hostname.includes('qa-') ? 'dev' : 'prod',
  });
}

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <Router history={history}>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
